"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AddToBag = require("./AddToBag");
Object.keys(_AddToBag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AddToBag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AddToBag[key];
    }
  });
});
